import { render, staticRenderFns } from "./CartsProductsModal.vue?vue&type=template&id=6c94c232&"
import script from "./CartsProductsModal.vue?vue&type=script&lang=js&"
export * from "./CartsProductsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports